module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/avecalvar-bkg-5a8ddd314648b2af2a1b5a8ce28f8cbd.jpg";